import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

// Selalu mengembalikan array periode polos (v1/periode, tanpa paging).
// Dipakai oleh banyak halaman sebagai sumber dropdown periode - jangan pakai
// untuk hasil pageable, itu bentuknya {data:{result,page}} bukan array (lihat
// getPeriodePageable) - kalau tercampur, .map di useStringifyOptions error.
export const getPeriode = createAsyncThunk("periode/getAll",
async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get('v1/periode');
    return response.data;
});

// Hasil pageable (v1/periode/pageable) untuk halaman Master Data > Periode
// (ShowPeriode). Disimpan terpisah dari dataAllPeriode - lihat catatan di atas.
export const getPeriodePageable = createAsyncThunk("periode/getPeriodePageable",
async({page, pageSize, search}) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const searchParams = search === undefined ? "" : search;
    const url = `v1/periode/pageable?page=${page}&size=${pageSize}&search=${searchParams}`
    const response = await jwtAuthAxios.get(url);
    return response.data;
});

export const getPeriodeActive = createAsyncThunk("periode/getPeriodeActive",
async({page, pageSize, search}) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const searchParams = search === undefined ? "" : search;
    let url = `v1/periode/active`;
    const response = await jwtAuthAxios.get(url);
    return response.data;
});

// Daftar periode aktif (siakad.t_periode_active dengan active = true), bisa lebih dari 1 baris.
export const getListPeriodeActive = createAsyncThunk("periode/getListPeriodeActive",
async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/periode/active-list`);
    return response.data;
});

export const getPeriodeById = createAsyncThunk("periode/getById", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/periode/${id}`);
    
    return response.data;
});

export const deletePeriode = createAsyncThunk("periode/delete", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    await jwtAuthAxios.delete(`v1/periode/${id}`);
    return id;
});

export const savePeriode = createAsyncThunk("periode/save", async(payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/periode',payload);
    return response.data;
});
export const updatePeriode = createAsyncThunk("periode/update", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    console.log("request : ",request)
    const response = await jwtAuthAxios.put('v1/periode',request);
    return response.data;
});

const periodeEntity = createEntityAdapter({
    selectId: (periode) => periode.id
});

const initialState = {
    dataAllPeriode: [],
    periodePageable: {},
    loadingPageable: false,
    periodeActive: {},
    listPeriodeActive: [],
    loadingPeriodeActive: false
}


const periodeSlice = createSlice({
    name:"periode",
    initialState: initialState,
    extraReducers: {
        [getPeriode.pending] : (state, action) => {
            state.loading = true;
        },
        [getPeriode.fulfilled] : (state, action) => {
            state.dataAllPeriode = action.payload;
            state.loading = false;
        },
        [getPeriode.rejected] : (state, action) => {
            state.loading = false;
        },

        [getPeriodePageable.pending] : (state, action) => {
            state.loadingPageable = true;
        },
        [getPeriodePageable.fulfilled] : (state, action) => {
            state.periodePageable = action.payload;
            state.loadingPageable = false;
        },
        [getPeriodePageable.rejected] : (state, action) => {
            state.loadingPageable = false;
        },

        [getPeriodeActive.pending] : (state, action) => {
            state.loading = true;
        },
        [getPeriodeActive.fulfilled] : (state, action) => {
            state.periodeActive = action.payload;
            state.loading = false;
        },
        [getPeriodeActive.rejected] : (state, action) => {
            state.loading = false;
        },
        
        
        [getListPeriodeActive.pending] : (state, action) => {
            state.loadingPeriodeActive = true;
        },
        [getListPeriodeActive.fulfilled] : (state, action) => {
            state.listPeriodeActive = Array.isArray(action.payload) ? action.payload : [];
            state.loadingPeriodeActive = false;
        },
        [getListPeriodeActive.rejected] : (state, action) => {
            state.listPeriodeActive = [];
            state.loadingPeriodeActive = false;
        },

        [getPeriodeById.fulfilled] : (state, action) => {

        },
        [savePeriode.fulfilled] : (state, action) => {
        },
        [deletePeriode.fulfilled] : (state, action) => {
        },
        [updatePeriode.fulfilled] : (state, action) => {
        }
    }
})

export const periodeSelectors = (state => state.periode);
export default periodeSlice.reducer;
